import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useAuthStore } from '../store/auth-store';
export function ServerConfig() {
    const { serverUrl, setServerUrl, isLoading, error } = useAuthStore();
    const [url, setUrl] = useState(serverUrl || 'http://localhost:8080');
    const [testing, setTesting] = useState(false);
    const [testResult, setTestResult] = useState(null);
    const handleTest = async () => {
        setTesting(true);
        setTestResult(null);
        try {
            const res = await fetch(`${url.replace(/\/+$/, '')}/api/health`);
            const data = await res.json();
            if (data.status === 'ok') {
                setTestResult('Connection successful');
            }
            else {
                setTestResult('Unexpected response');
            }
        }
        catch (e) {
            setTestResult(e instanceof Error ? e.message : 'Connection failed');
        }
        finally {
            setTesting(false);
        }
    };
    const handleSave = () => {
        setServerUrl(url);
        setTestResult('Saved');
    };
    return (_jsxs("div", { className: "card p-6", children: [_jsx("h3", { className: "text-lg font-semibold text-text-primary mb-4", children: "Server Configuration" }), _jsxs("div", { className: "space-y-4", children: [_jsxs("div", { children: [_jsx("label", { className: "block text-sm font-medium text-text-secondary mb-2", children: "Server URL" }), _jsxs("div", { className: "flex gap-2", children: [_jsx("input", { type: "text", value: url, onChange: e => setUrl(e.target.value), placeholder: "http://localhost:8080", className: "input flex-1" }), _jsx("button", { onClick: handleTest, disabled: testing, className: "px-3 py-2 bg-gray-100 rounded-md text-sm hover:bg-gray-200 disabled:opacity-50", children: testing ? 'Testing...' : 'Test' }), _jsx("button", { onClick: handleSave, className: "btn-primary", children: "Save" })] })] }), testResult && (_jsx("p", { className: `text-sm ${testResult === 'Connection successful' || testResult === 'Saved' ? 'text-green-600' : 'text-red-600'}`, children: testResult })), isLoading && _jsx("p", { className: "text-sm text-gray-500", children: "Loading..." }), error && _jsx("p", { className: "text-sm text-red-600", children: error })] })] }));
}
//# sourceMappingURL=ServerConfig.js.map